import React from "react";

//layoutpages
import Default from "../layouts/dashboard/default";

import { DefaultRouter } from "./default-router";
import { Layout1Router } from "./layout1-router";
import ScrollToTop from "../components/ScrollToTop";

export const IndexRouters = [
  {
    path: "/",
    element: (
      <>
        <ScrollToTop />
        <Default />
      </>
    ),
    children: [...DefaultRouter, ...Layout1Router],
  },
];
